import { defineComponent as t, createElementBlock as n, openBlock as o, renderSlot as r } from "vue";
const c = /* @__PURE__ */ t({
  __name: "TransitionableSlot",
  setup(l) {
    return (e, a) => (o(), n("div", null, [
      r(e.$slots, "default")
    ]));
  }
});
export {
  c as default
};
